exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".coinDetailsModal .coinTable td{padding:.7rem .5rem}.coinDetailsModal .coinTable .totalCoinsRow{border-top:1px solid #ddd}.coinDetailsModal .subCoins{opacity:.7;text-align:right}.coinDetailsModal .coinMaxDisclaimer{font-size:.8em;text-align:center}.coinDetailsModal .hiddenElement{display:none}.coinDetailsModal .reactionFeedback{float:right}.smallSize .modal-dialog{width:400px}.smallSize .coinTable{margin-left:auto;margin-right:auto}.fullSize .modal-body{min-height:300px}.fullSize .modal-dialog{width:800px;overflow:hidden}.fullSize .coinTable{margin-left:15px;font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/shelves/coin_details_modal.scss
// module id = 1403
// module chunks = 0